/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const saveTeamPhoneSettingsBodyVersionMin = 0;
export const saveTeamPhoneSettingsBodyVersionMax = 9007199254740991;

export const saveTeamPhoneSettingsBodyInboundNumberOneRegExp = new RegExp('^\\+[1-9][0-9]{1,14}$');
export const saveTeamPhoneSettingsBodyMessagesInboundGreetingTwoTextMax = 400;

export const saveTeamPhoneSettingsBodyMessagesInboundGreetingThreeAssetIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const saveTeamPhoneSettingsBodyMessagesClientCodePromptTwoTextMax = 80;

export const saveTeamPhoneSettingsBodyMessagesClientCodePromptThreeAssetIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const saveTeamPhoneSettingsBodyMessagesBeforeTransferTwoTextMax = 80;

export const saveTeamPhoneSettingsBodyMessagesBeforeTransferThreeAssetIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const saveTeamPhoneSettingsBodyMessagesVoicemailPromptTwoTextMax = 200;

export const saveTeamPhoneSettingsBodyMessagesVoicemailPromptThreeAssetIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);

export const SaveTeamPhoneSettingsBody = zod.object({
  version: zod
    .int()
    .min(saveTeamPhoneSettingsBodyVersionMin)
    .max(saveTeamPhoneSettingsBodyVersionMax),
  inboundNumber: zod.union([
    zod.string().regex(saveTeamPhoneSettingsBodyInboundNumberOneRegExp),
    zod.null(),
  ]),
  codeRequired: zod.boolean(),
  messages: zod.object({
    inboundGreeting: zod.union([
      zod.object({
        mode: zod.literal('default'),
      }),
      zod.object({
        mode: zod.literal('tts'),
        text: zod.string().min(1).max(saveTeamPhoneSettingsBodyMessagesInboundGreetingTwoTextMax),
      }),
      zod.object({
        mode: zod.literal('mp3'),
        assetId: zod
          .uuid()
          .regex(saveTeamPhoneSettingsBodyMessagesInboundGreetingThreeAssetIdRegExp),
      }),
    ]),
    clientCodePrompt: zod.union([
      zod.object({
        mode: zod.literal('default'),
      }),
      zod.object({
        mode: zod.literal('tts'),
        text: zod.string().min(1).max(saveTeamPhoneSettingsBodyMessagesClientCodePromptTwoTextMax),
      }),
      zod.object({
        mode: zod.literal('mp3'),
        assetId: zod
          .uuid()
          .regex(saveTeamPhoneSettingsBodyMessagesClientCodePromptThreeAssetIdRegExp),
      }),
    ]),
    beforeTransfer: zod.union([
      zod.object({
        mode: zod.literal('default'),
      }),
      zod.object({
        mode: zod.literal('tts'),
        text: zod.string().min(1).max(saveTeamPhoneSettingsBodyMessagesBeforeTransferTwoTextMax),
      }),
      zod.object({
        mode: zod.literal('mp3'),
        assetId: zod
          .uuid()
          .regex(saveTeamPhoneSettingsBodyMessagesBeforeTransferThreeAssetIdRegExp),
      }),
    ]),
    voicemailPrompt: zod.union([
      zod.object({
        mode: zod.literal('default'),
      }),
      zod.object({
        mode: zod.literal('tts'),
        text: zod.string().min(1).max(saveTeamPhoneSettingsBodyMessagesVoicemailPromptTwoTextMax),
      }),
      zod.object({
        mode: zod.literal('mp3'),
        assetId: zod
          .uuid()
          .regex(saveTeamPhoneSettingsBodyMessagesVoicemailPromptThreeAssetIdRegExp),
      }),
    ]),
  }),
});

export type SaveTeamPhoneSettingsBody = zod.input<typeof SaveTeamPhoneSettingsBody>;
export type SaveTeamPhoneSettingsBodyOutput = zod.output<typeof SaveTeamPhoneSettingsBody>;
